import { SvgProps } from './interface/SvgProps';

const SvgAllDay = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    viewBox="0 0 67 67"
    {...props}
  >
      <path
        stroke="#19120C"
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M25.157 17.343 19.5 23l-2.828-2.828"
      />
      <rect width={40} height={40} fill="#0B7D75" rx={20} />
      <path
        stroke="#fff"
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M28.595 15.572 19.167 25l-4.714-4.714"
      />
    </svg>
);
  
export default SvgAllDay;
